<template>
    <div>
         <div class="top">错误页</div>
          <van-empty description="暂无数据，请先登录" />
    </div>
</template>

<script>
export default {
        
    }
</script>

<style lang="scss" scoped>
.top {
  width: 375px;
  height: 44px;
  background-color: #dd0000;
  height: 44px;
  text-align: center;
  font-family: MicrosoftYaHei;
  font-size: 17px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 44px;
  letter-spacing: 1px;
  color: #ffffff;
}
</style>